import { MDSDropdown } from '@marqvision/mds-v2';
import { MarqCommonEnumsListingPostTypeEnum } from '~/swagger/data-contracts';
import { useLogger } from '~/hooks';
import { getListingTabGroup } from '~/utils';
import { ResponsiveProps } from '~/components/Responsive/@types';
import { useGetFilterParams, usePathParams } from './@hooks';

const options = [
  { value: null, label: 'All' },
  { value: MarqCommonEnumsListingPostTypeEnum.Post, label: 'Post' },
  { value: MarqCommonEnumsListingPostTypeEnum.Profile, label: 'Profile' },
];

export const PostTypeFilter = (props: ResponsiveProps) => {
  const { size = 'medium' } = props;
  const { requestFilterParams, setParams } = useGetFilterParams();
  const { post_type_filter } = requestFilterParams;
  const { page, listingStatus } = usePathParams();

  const { amplitudeLogging } = useLogger();

  const handleChange = (value: MarqCommonEnumsListingPostTypeEnum | null) => {
    if (value) {
      amplitudeLogging('applied filter', {
        Type: 'post type',
        Channel: page,
        Page: getListingTabGroup(listingStatus),
      });
    }

    setParams({
      post_type_filter: value,
    });
  };

  return (
    <MDSDropdown
      label="Post/Profile"
      value={post_type_filter ?? null}
      list={options}
      onChange={handleChange}
      modules={[
        {
          type: 'filter-button',
          size,
        },
      ]}
    />
  );
};
